<template>
  <div class="caption-and-select-container">
    <span class="caption">年份范围</span>
    <!-- 替换为起始年份+截止年份选择 -->
    <div style="display: flex; align-items: center; gap: 8px;">
      <a-select v-model:value="startYear" class="select" placeholder="起始年份">
        <a-select-option v-for="opt in yearOptionsWithoutAll" :key="opt.key" :value="opt.value">
          {{ opt.label }}
        </a-select-option>
      </a-select>
      <span style="color: #666;">-</span>
      <a-select v-model:value="endYear" class="select" placeholder="截止年份">
        <a-select-option v-for="opt in yearOptionsWithoutAll" :key="opt.key" :value="opt.value">
          {{ opt.label }}
        </a-select-option>
      </a-select>
    </div>
  </div>
  <a-spin :spinning="spinning">
    <a-row :gutter="16" justify="center">
      <a-col v-for="(stat, index) in stats" :key="index" :span="6">
        <!-- 统计卡片 -->
        <div :style="statStyle">
          <!-- 图标和内容并列 -->
          <div :style="iconStyle">
            <component :is="stat.icon" />
          </div>
          <!-- 统计内容 -->
          <div class="stat-content">
            <div class="stat-title">{{ stat.title }}</div>
            <div class="stat-value-row">
              <!-- TOP贡献特殊处理 -->
              <div v-if="stat.title === 'TOP 贡献'" class="contributor-name">
                {{ stat.value }}
              </div>
              <div v-else>
                <div class="stat-value">{{ formatNumber(stat.value) }}</div>
              </div>
              <span class="stat-suffix">{{ stat.suffix }}</span>
            </div>
            <!-- TOP贡献者代码量 -->
            <div v-if="stat.title === 'TOP 贡献'" class="stat-code-amount">
              代码量：{{ formatNumber(topContributorCodeLines) }} 行
            </div>
          </div>
        </div>
      </a-col>
    </a-row>

    <div :style="pieCardStyle">
      <div style="display: flex; align-items: baseline; justify-content: space-between;">
        <span style="display: flex; align-items: center;">
          <span :style="pieCardIconStyle">
            <component :is="pieSelection === 'contributor' ? TeamOutlined : CodeOutlined" />
          </span>
          <span class="pies-and-table-card-title">
            {{ pieSelection === 'contributor' ? "贡献者构成占比" : "代码量构成占比" }}
          </span>
        </span>
        <a-radio-group v-model:value="pieSelection">
          <a-radio-button value="contributor">贡献者</a-radio-button>
          <a-radio-button value="code">代码量</a-radio-button>
        </a-radio-group>
      </div>
      <div class="pie-and-table-cards-flex">
        <div class="pie-and-table-card">
          <!-- left chart and data -->
          <div class="pie-title-container">
            <div class="pie-title">
              华为 vs 非华为
            </div>
          </div>
          <div style="height: 100%;">
            <div style="height: 230px;">
              <my-pie-chart :data="leftPieData[pieSelection]" :colors="huaweiNonHuaweiColors"
                :suffix="pieSelection === 'contributor' ? '人' : '行'" />
            </div>
            <div style="display: flex;">
              <div v-for="(data, index) in leftPieData[pieSelection]" :key="index" class="pie-data-box"
                :style="{ borderColor: huaweiNonHuaweiColors[index] }">
                <div class="pie-data-title" style="margin-bottom: 6px;">
                  <span class="pie-data-dot" :style="{ color: huaweiNonHuaweiColors[index] }">●</span>
                  {{ data.name }}
                </div>
                <span style="font-size: 20px; font-weight: 600; ">
                  {{ formatNumber(data.value) }}
                </span>
                <span class="pie-data-suffix">
                  {{ pieSelection === 'contributor' ? ' 人' : ' 行' }}
                </span>
                <div style="font-size: 12px; color: #666; margin-top: 5px; ">
                  占比 {{((data.value / leftPieData[pieSelection].reduce((sum, item) => sum + item.value, 0)) *
                    100).toFixed(2)}}%
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pie-and-table-card" style="min-width: 60%;">
          <!-- right chart and data -->
          <div class="pie-title-container">
            <div class="pie-title">非华为构成</div>
            <my-dropdown-checkbox v-model:checkedList="nonHuaweiCheckedList" :options="rightPieOptions" />
          </div>
          <div style="display: flex; align-items: flex-start;">
            <div style="width: 320px;">
              <my-pie-chart :data="rightPieData[pieSelection]" :colors="rightPieColors"
                :dimmed-names="rightPieDimmedNames" :suffix="pieSelection === 'contributor' ? '人' : '行'" />
            </div>
            <div style="flex: 1; display: flex; flex-direction: column; gap: 10px; padding-right: 8px;">
              <div v-for="(data, index) in displayedRightPieData" :key="index" class="pie-data-box"
                @click="toggleNonHuawei(data.name)" :class="{ 'pie-data-box-clickable': data.name !== '合计' }"
                :style="getRightPieItemStyle(data)">
                <div class="pie-data-title">
                  <span class="pie-data-dot" :style="{
                    color: isDimmed(data.name) ?
                      toRgba(getNonHuaweiColor(data.name), dimOpacity)
                      : getNonHuaweiColor(data.name)
                  }">
                    ●
                  </span>
                  {{ data.name }}
                </div>
                <div style="text-align: right;">
                  <span style="font-size: 16px; font-weight: 600; ">
                    {{ formatNumber(data.value) }}
                  </span>
                  <span class="pie-data-suffix">
                    {{ pieSelection === 'contributor' ? ' 人' : ' 行' }}
                  </span>
                  <div style="font-size: 12px; margin-top: 2px; ">
                    占非华为 {{ ((data.value / rightPieTotalSum) * 100).toFixed(2) }}% | 占总体 {{ ((data.value /
                      leftPieTotalSum) * 100).toFixed(2) }}%
                  </div>
                </div>
              </div>
              <div class="pie-data-box pie-data-total-box">
                <div class="pie-data-title">
                  <span class="pie-data-dot" style="color: #6366F1; font-size: 18px; margin-right: 2px;">∑</span>
                  <span style="font-weight: 700;">合计</span>
                </div>
                <div style="text-align: right;">
                  <span style="font-size: 16px; font-weight: 600; ">
                    {{ formatNumber(rightPieDataSum) }}
                  </span>
                  <span class="pie-data-suffix">
                    {{ pieSelection === 'contributor' ? ' 人' : ' 行' }}
                  </span>
                  <div style="font-size: 12px; margin-top: 2px; ">
                    占非华为 {{ rightPieTotalSum ? ((rightPieDataSum / rightPieTotalSum) * 100).toFixed(2) :
                      '0.00' }}% | 占总体 {{ leftPieTotalSum ? ((rightPieDataSum / leftPieTotalSum) *
                      100).toFixed(2) : '0.00' }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script setup>
import { computed, ref, watch, onMounted } from 'vue';
import axios from 'axios';
import { notification } from 'ant-design-vue';
import { TeamOutlined, CodeOutlined, CrownOutlined, EnvironmentOutlined } from '@ant-design/icons-vue';
import MyPieChart from '../components/MyPieChart.vue';
import MyDropdownCheckbox from '../components/MyDropdownCheckbox.vue';

/* global defineProps */
const props = defineProps({
  dimension: {
    type: String,
    required: true
  },
  currentColor: {
    type: String,
    required: true
  }
});

// ----- Constants & lookups -----
const requestParamProjectMap = { all: '', master: 'openharmony', sig: 'openharmony-sig', tpc: 'openharmony-tpc' };
const nonHuaweiOrder = ['HABO', 'DONATE', 'PARTNER', 'SCHOOL', 'OTHERS'];
const nonHuaweiNameMap = { HABO: '伙伴：哈勃', DONATE: '伙伴：捐赠单位', PARTNER: '伙伴：其他', SCHOOL: '高校', OTHERS: '其他' };
const huaweiNonHuaweiColors = ['#EF4444', '#3B82F6'];
const nonHuaweiColorMap = {
  '伙伴：哈勃': '#15803D',
  '伙伴：捐赠单位': '#16A34A',
  '伙伴：其他': '#22C55E',
  '高校': '#60A5FA',
  '其他': '#A78BFA'
};
const years = Array.from({ length: 2026 - 2020 + 1 }, (_, i) => 2020 + i);
// 移除all选项，仅保留年份选项
const yearOptionsWithoutAll = years.map((y) => ({ key: y, label: String(y), value: y }));

// ----- Helpers -----
const formatNumber = (n) => {
  if (n === null || n === undefined) return '';
  const num = typeof n === 'number' ? n : Number(n);
  return Number.isNaN(num) ? n : num.toLocaleString();
};

const buildNonHuaweiContributor = (situations) => {
  // 依据固定顺序把后端枚举映射成饼图数据
  const contributorArr = [];
  for (const key of nonHuaweiOrder) {
    const item = situations.find((s) => s.remarks === key);
    if (item) contributorArr.push({ name: nonHuaweiNameMap[key], value: item.number });
  }
  return contributorArr;
};

const buildNonHuaweiCode = (situations) => {
  const codeArr = [];
  for (const key of nonHuaweiOrder) {
    const item = situations.find((s) => s.remarks === key);
    if (item) codeArr.push({ name: nonHuaweiNameMap[key], value: item.codeLines });
  }
  return codeArr;
};

const getSituationCodeLines = (situations, remark) => {
  const item = situations.find((s) => s.remarks === remark);
  return item?.codeLines ?? 0;
};

const getNonHuaweiColor = (name) => nonHuaweiColorMap[name] || '#A78BFA';

const dimOpacity = 0.1;
const toRgba = (color, alpha) => {
  if (!color) return color;
  if (!color.startsWith('#')) return color;
  const hex = color.slice(1);
  const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex;
  if (full.length !== 6) return color;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// 新增：年份范围合法性校验
const validateYearRange = () => {
  // 未选择年份时提示
  if (!startYear.value || !endYear.value) {
    notification.warning({ message: '请选择完整的年份范围（起始年份+截止年份）' });
    return false;
  }
  // 起始年份大于截止年份时提示
  if (startYear.value > endYear.value) {
    notification.warning({ message: '起始年份不能大于截止年份，请重新选择' });
    return false;
  }
  return true;
};

// ----- State -----
const pieSelection = ref('contributor');
const spinning = ref(false);
// 缓存key调整为：维度 -> 起始年份-截止年份
const cache = ref({ all: {}, master: {}, sig: {}, tpc: {} });
const nonHuaweiCheckedList = ref([]);
// 替换原year为起始/截止年份，设置默认值（2020-2026）
const startYear = ref(2020);
const endYear = ref(2026);

// ----- Derived state -----
// 生成缓存key：起始年份-截止年份（如 "2020-2023"）
const yearRangeKey = computed(() => {
  if (!startYear.value || !endYear.value) return '';
  return `${startYear.value}-${endYear.value}`;
});
const currentCache = computed(() => cache.value[props.dimension][yearRangeKey.value] || {});
const stats = computed(() => [{
  title: '贡献者数量',
  value: currentCache.value.totalNum,
  suffix: '人',
  icon: TeamOutlined
}, {
  title: '代码量',
  value: currentCache.value.totalCodeLines,
  suffix: '行',
  icon: CodeOutlined
}, {
  title: '组织数量',
  value: currentCache.value.organizationNum,
  suffix: '家',
  icon: EnvironmentOutlined
}, {
  title: 'TOP 贡献',
  value: currentCache.value.topContributor,
  suffix: '',
  icon: CrownOutlined
}]);
const topContributorCodeLines = computed(() => currentCache.value.topContributorCodeLines);
const leftPieData = computed(() => currentCache.value.leftPieData || { contributor: [], code: [] });
const rightPieData = computed(() => currentCache.value.rightPieData || { contributor: [], code: [] });
const rightPieColors = computed(() => (rightPieData.value[pieSelection.value] || []).map((item) =>
  getNonHuaweiColor(item.name)));
const rightPieOptions = computed(() => (rightPieData.value[pieSelection.value] || []).map((item) => item.name));
// 用于监听选项变化，避免深度比较开销
const rightPieOptionsKey = computed(() => rightPieOptions.value.join('|'));
const leftPieTotalSum = computed(() => {
  const data = leftPieData.value[pieSelection.value] || [];
  return data.reduce((sum, item) => sum + item.value, 0);
});
const rightPieTotalSum = computed(() => {
  const data = rightPieData.value[pieSelection.value] || [];
  return data.reduce((sum, item) => sum + item.value, 0);
});
const displayedRightPieData = computed(() => rightPieData.value[pieSelection.value] || []);
const rightPieDataSum = computed(() => {
  return displayedRightPieData.value
    .filter((item) => !isDimmed(item.name))
    .reduce((sum, item) => sum + item.value, 0);
});
const rightPieDimmedNames = computed(() => {
  const selectedSet = new Set(nonHuaweiCheckedList.value);
  return (rightPieData.value[pieSelection.value] || [])
    .filter((item) => !selectedSet.has(item.name))
    .map((item) => item.name);
});

const isDimmed = (name) => rightPieDimmedNames.value.includes(name);

const toggleNonHuawei = (name) => {
  if (name === '合计') return;
  const current = new Set(nonHuaweiCheckedList.value);
  if (current.has(name)) {
    current.delete(name);
  } else {
    current.add(name);
  }
  nonHuaweiCheckedList.value = Array.from(current);
};

const getRightPieItemStyle = (item) => {
  const dimmed = isDimmed(item.name);
  const color = getNonHuaweiColor(item.name);
  return {
    borderColor: dimmed ? toRgba(color, dimOpacity) : color,
    backgroundColor: dimmed ? 'transparent' : '#FFFFFF',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '7px 16px',
    color: dimmed ? '#9CA3AF' : '#111827'
  };
};

// ----- API fetchers -----
const fetchData = async (val) => {
  // 上半区：概览 + TOP 贡献者
  const project = requestParamProjectMap[val];
  // 调整API入参：替换year为startYear和endYear
  const res = await axios.get('/metric/getOverallSituation', { 
    params: { 
      project: project, 
      startYear: startYear.value, 
      endYear: endYear.value 
    } 
  });
  const rankRes = await axios.get('/metric/contributorRank', { 
    params: { 
      project: project, 
      startYear: startYear.value, 
      endYear: endYear.value 
    } 
  });
  if (res.data.code === 200 && rankRes.data.code === 200) {
    const data = res.data.data;
    const rankData = rankRes.data.data;
    // 缓存key使用年份范围
    cache.value[val][yearRangeKey.value] = {
      totalNum: data.totalNum,
      totalCodeLines: data.totalCodeLines,
      organizationNum: data.organizationNum,
      topContributor: rankData[0].contributor,
      topContributorCodeLines: rankData[0].codeLines,
      leftPieData: {
        contributor: [
          { name: '华为', value: data.huaweiNum },
          { name: '非华为', value: data.nonHuaweiNum }
        ],
        code: [
          { name: '华为', value: getSituationCodeLines(data.situations || [], 'HUAWEI') },
          { name: '非华为', value: (data.totalCodeLines || 0) - getSituationCodeLines(data.situations || [], 'HUAWEI') }
        ]
      },
      rightPieData: {
        contributor: buildNonHuaweiContributor(data.situations || []),
        code: buildNonHuaweiCode(data.situations || [])
      }
    };
  } else {
    throw new Error(res.data?.msg || '请求失败');
  }
};

const loadData = async (val) => {
  // 新增：先校验年份范围合法性
  if (!validateYearRange()) return;
  
  // 有缓存则跳过，减少重复请求
  if (cache.value[val][yearRangeKey.value]) return;
  
  spinning.value = true;
  try {
    await fetchData(val);
  } catch (error) {
    notification.error({ message: '数据加载失败', description: error?.message || error });
  } finally {
    spinning.value = false;
  }
};

// ----- Watchers & lifecycle -----
// 监听维度、起始年份、截止年份变化，刷新数据
watch([() => props.dimension, startYear, endYear], async ([dimension]) => {
  // 切换维度或年份范围时刷新上半区数据
  await loadData(dimension);
});

watch(
  rightPieOptionsKey,
  () => {
    // 数据源变化时，保持勾选与选项一致
    const options = rightPieOptions.value;
    nonHuaweiCheckedList.value = [...options];
  },
  { immediate: true }
);

onMounted(async () => {
  // 首屏加载：默认年份范围已设置，直接请求
  await loadData(props.dimension);
});

// ----- Styles -----
const statStyle = computed(() => ({
  border: `2px solid ${props.currentColor}`,
  backgroundColor: '#fff',
  padding: '18px',
  borderRadius: '20px',
  transition: 'border-color 0.15s',
  minHeight: '110px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%'
}));

const iconStyle = computed(() => ({
  width: '56px',
  height: '56px',
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: props.currentColor + '14',
  color: props.currentColor,
  fontSize: '22px',
  marginRight: '12px'
}));

const pieCardIconStyle = computed(() => ({
  width: '32px',
  height: '32px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: props.currentColor + '14',
  color: props.currentColor,
  fontSize: '16px',
  marginRight: '8px'
}));

const pieCardStyle = computed(() => ({
  border: `2px solid ${props.currentColor}`,
  backgroundColor: '#fff',
  padding: '24px 24px 0 24px',
  borderRadius: '20px',
  transition: 'border-color 0.15s',
  margin: '24px 0 24px 0'
}));
</script>

<style scoped>
.stat-content {
  flex: 1;
  text-align: center;
}

.stat-title {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  margin-bottom: 6px;
}

.stat-value-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1;
}

.stat-suffix {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-left: 6px;
}

.contributor-name {
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s;
  word-break: break-all;
}

.stat-code-amount {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 4px;
}

.pies-and-table-card-title {
  font-size: 16px;
  font-weight: 600;
}

.pie-and-table-card {
  flex: 1;
  margin-top: 16px;
  margin-bottom: 24px;
  padding: 24px 16px 24px 16px;
  background-color: #f9fafb;
  border-radius: 12px;
}

.pie-and-table-cards-flex {
  display: flex;
  gap: 24px;
}

.pie-data-box {
  background-color: #fff;
  border: 2px solid;
  border-radius: 12px;
  padding: 12px 16px;
  width: 100%;
  flex: 1;
  margin: 0 8px;
  background-clip: padding-box;
  align-items: center;
  text-align: left;
}

.pie-data-title {
  font-size: 14px;
  display: flex;
  align-items: baseline;
  font-weight: 500;
}

.pie-data-dot {
  font-weight: 600;
  font-family: 'MS Mincho', 'SimSun', 'serif';
  margin-right: 4px;
}

.pie-data-suffix {
  font-size: 12px;
  margin-top: 4px;
}

.pie-data-total-box {
  border-color: #95A5F5;
  background-color: #EFF6FF;
  border-width: 2px;
  color: #4338CA;
  display: flex;
  justify-content: space-between;
  padding: 7px 16px;
  box-shadow: 0 0 12px 2px #95A5F533;
}

.pie-title-container {
  margin-bottom: 16px;
  padding-left: 16px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.pie-data-box-clickable {
  cursor: pointer;
}

.pie-title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 600;
}

.caption-and-select-container {
  text-align: left;
  margin-right: 24px;
  margin-bottom: 16px;
}

.caption {
  margin-right: 8px;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.select {
  width: 120px;
}
</style>